<template>
  <div>
    <div>{{ stopLine }}</div>
    <div>{{ originalStopLine }}</div>
    <div>{{ addedAtLine }}</div>
  </div>
</template>

<script>
import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js';
import moment from 'moment';

export default {
  name: 'NewVirtualStopRenderer',
  props: {
    eventType: {
      type: String,
      required: true,
    },
    eventData: {
      type: String,
      required: true,
    }
  },
  computed: {
    stopLine() {
      const stopId = erm.getValueOutOfGivenKey('stopId', this.eventData);
      const label = erm.getTranslationForEventDescription(this.eventType);
      if (!label) return this.eventData;
      return `${label} ${stopId}`;
    },
    originalStopLine() {
      const originalStopId = erm.getValueOutOfGivenKey('originalStopId', this.eventData);
      const label = this.$t('system_event.objects_in_filters_and_table.eventDescription.original_stop');
      return `${label}: ${originalStopId}`;
    },
    addedAtLine() {
      const tallennettu = erm.getValueOutOfGivenKey('tallennettu', this.eventData);
      if (!tallennettu) return '';
      const label = this.$t('system_event.objects_in_filters_and_table.eventDescription.added_at');
      const formatted = moment(tallennettu).format('DD.MM.YYYY HH:mm');
      return `${label}: ${formatted}`;
    }
  }
};
</script>
